import React from 'react';

function AboutSection() {
  return (
    <section className="section" style={{ padding: '100px 0', flex: 1 }}>
      <div className="section-title">
        <h2 style={{ color: '#fff' }}>Présentation</h2>
        <div className="title-bar"></div>
        <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.8)' }}>
          
        </p>
      </div>
      <div className="container">
        <div className="about-content" style={{ background: 'rgba(255,255,255,0.9)', padding: '40px', borderRadius: 8 }}>
          <div className="about-text">
            <p>
              DLA STRUCTURE est votre bureau d'études spécialisé dans l'ingénierie du gros œuvre. Nous calculons, sécurisons et optimisons vos projets de construction ou de réhabilitation, du dessin à la réalisation sur chantier.
            </p>
            <br />
            <h3 style={{ fontSize: 22, marginBottom: 15, color: 'var(--dark)' }}>📐 Notre terrain d'action : le Béton & le Métal</h3>
            <p><strong>Béton Armé :</strong> Calculs de dalles, poteaux, poutres, fondations et soutènements.</p>
            <p><strong>Charpente Métallique :</strong> Structures complexes, surélévations et renforts, rénovations lourdes.</p>
            <br />
            <h3 style={{ fontSize: 22, marginBottom: 15, color: 'var(--dark)' }}>⚙️ Nos prestations clés</h3>
            <p><strong>Faisabilité & Diagnostic :</strong> Valider vos projets de modification (ouverture de mur porteur, extension).</p>
            <p><strong>Dimensionnement :</strong> Calculer précisément les sections et optimiser la quantité de matière.</p>
            <p><strong>Plans d'Exécution :</strong> Fournir les plans d'armatures et de coffrage directement exploitables par le chantier.</p>
            <p><strong>Avis Techniques :</strong> Expertises ciblées pour valider la conformité de vos ouvrages.</p>
            <br />
            <h3 style={{ fontSize: 22, marginBottom: 15, color: 'var(--dark)' }}>🛠️ Le + technologique</h3>
            <p>
              Nous travaillons en modélisation BIM (Building Information Modeling). Vos maquettes 3D sont ultra-précises, ce qui évite les erreurs sur le chantier et facilite la coordination entre tous les corps d'état.
            </p>
            <br />
            
          </div>
          <div className="about-image">
            {/*<img src="https://placehold.co/600x400/ffb922/232529?text=DLA+STRUCTURE" alt="DLA Structure" />*/}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
